import { resetOriginalTitle } from './notification-title';
let applicationFocus = true;

const exitFocusAplication = () => {
  applicationFocus = false;
};

const returnApplicationFocus = () => {
  applicationFocus = true;
  resetOriginalTitle();
};

export const getApplicationFocus = () => applicationFocus;

window.addEventListener('blur', exitFocusAplication);
window.addEventListener('focus', returnApplicationFocus);
